import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// Redux
import { store } from "app/store";
import { Provider } from "react-redux";

import config from "./config";

import App from "App";
import "assets/scss/style.scss";
import * as serviceWorker from "serviceWorker";

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <Provider store={store}>
    <BrowserRouter basename={config.basename}>
      <App />
    </BrowserRouter>
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
